import { SMAAEffect } from 'postprocessing'
import { wrapEffect } from '../util'

export const SMAA = wrapEffect(SMAAEffect)
